<div class="card-user" (click)="onRowClick(dados)">
    <div class="code">
        <span>Código</span>
        <h4>{{ codigo || 'Não disponível' }}</h4>
    </div>

    <article class="tittle2">
        <span>Nome</span>
        <h4>{{ nome || 'Não disponível' }}</h4>
    </article>

    <article class="tittle">
        <span>Email</span>
        <h4>{{ email || 'Não disponível' }}</h4>
    </article>

    <article>
        <span>Telemóvel</span>
        <h4>{{ telefone || 'Não disponível' }}</h4>
    </article>

    <article>
        <span>Data de Registro</span>
        <h4>{{ registo || 'Não disponível' }}</h4>
    </article>

    <div class="item-icon">
        <span>Estado</span>
        <p-tag [severity]="getSeverity(estado)" [value]="estado ? 'Activo' : 'Inactivo'"></p-tag>
    </div>

    <div class="flex justify-center items-center" (click)="$event.stopPropagation()">
        <p-menu #menuRef [model]="getMenuActions()" [popup]="true" appendTo="body" [autoZIndex]="true"
            [baseZIndex]="10000">
        </p-menu>

        <p-button icon="pi pi-ellipsis-v" severity="secondary" (click)="openMenu($event, menuRef)">
        </p-button>
    </div>

</div>